import pmseService from '../services/PmseService'
import label from '../assets/pmse/label.json'
import _ from 'lodash'
// import { data } from 'jquery'

function getStatusAliasModaPengirimanPMSE(status) {
    switch(status) {
        case pmseService.MODA_STATUS.STATUS_BELUM_INPUT:
          return 'Belum Input Data'
        case pmseService.MODA_STATUS.STATUS_EFORM_OPEN:
          return 'Belum Input Data'
        case pmseService.MODA_STATUS.STATUS_EFORM_DRAFT:
          return 'Sedang Input Data'
        case pmseService.MODA_STATUS.STATUS_EFORM_SUBMIT:
          return 'Selesai'
        case pmseService.MODA_STATUS.STATUS_KUNJUNGAN_OPEN:
          return 'Belum Input Data'
        case pmseService.MODA_STATUS.STATUS_KUNJUNGAN_UPLOAD:
          return 'Sudah Upload Data'
        case pmseService.MODA_STATUS.STATUS_KUNJUNGAN_VALIDASI:
          return 'Sedang Proses Validasi'
        case pmseService.MODA_STATUS.STATUS_KUNJUNGAN_REJECT:
          return 'Ditolak'
        case pmseService.MODA_STATUS.STATUS_KUNJUNGAN_DONE:
          return 'Selesai'
        case pmseService.MODA_STATUS.STATUS_UNGGAH_OPEN:
          return 'Belum Input Data'
        case pmseService.MODA_STATUS.STATUS_UNGGAH_UPLOAD:
          return 'Sudah Upload Data'
        case pmseService.MODA_STATUS.STATUS_UNGGAH_VALIDASI:
          return 'Sedang Proses Validasi'
        case pmseService.MODA_STATUS.STATUS_UNGGAH_REJECT:
          return 'Ditolak'
        case pmseService.MODA_STATUS.STATUS_UNGGAH_DONE:
          return 'Selesai'
        case pmseService.MODA_STATUS.STATUS_M2M_OPEN:
          return 'Belum Input Data'
        case pmseService.MODA_STATUS.STATUS_M2M_UPLOAD:
          return 'Sudah Upload Data'
        case pmseService.MODA_STATUS.STATUS_M2M_VALIDASI:
          return 'Sedang Proses Validasi'
        case pmseService.MODA_STATUS.STATUS_M2M_REJECT:
          return 'Ditolak'
        case pmseService.MODA_STATUS.STATUS_M2M_DONE:
          return 'Selesai'
        default:
          return 'Belum Input Data'
    }
}

function isRoleOperator(role_string) {
  const roles = getArrayRoles(role_string)
  const operatorRoles = [
    "ROLE_PMSE_OPERATOR_MP",
    "ROLE_PMSE_OPERATOR_ER",
    "ROLE_PMSE_OPERATOR_RH",
    "ROLE_PMSE_OPERATOR_CL_SC",
    "ROLE_PMSE_OPERATOR_DD_PH"
  ]
  for(const role of roles) {
    if(operatorRoles.includes(role)) return true
  }
  return false
}

function getArrayRoles(roles) {
  return roles.split(',').map(item => item.trim().replace('[','').replace(']',''))
}

// function rekursifSearch(components, dataKey) {
//   for (const component of components[0]) {
//     if(component.dataKey == dataKey) return component.label
//     if(component.hasOwnProperty('components')) {
//       return rekursifSearch(component.components, dataKey)
//     }
//   }
// }

function getQuestion(item) {
  // console.log(dataKey)
  const key = item.dash == 0 ? item.dataKey : item.dataKey.substring(0, item.dash - 1)
  const question = _.find(label, { dataKey: key })
  return question == null ? null : question.label
}

export {
    getStatusAliasModaPengirimanPMSE,
    getQuestion,
    isRoleOperator
}